'use strict';

angular.module('formonlineApp').service('ContextFiscal', function ($resource) {

    return $resource('api/contextefiscal/:id', {id: '@id'}, {
        'list': {method: 'GET', isArray: true},
        'update': {method: 'PUT'}
    });

});

angular.module('formonlineApp').service('ContextFiscalService', ['ContextFiscal', '$http',
    function (ContextFiscal, $http) {
        this.get = function (idStr) {
            return ContextFiscal.get({
                id: idStr
            }).$promise;
        };

        this.getByAnnee = function (annFis) {
            return $http({
                method: 'get',
                url: 'api/contextefiscal/annee/' + annFis
            });
        };

        this.getAnneesFiscales = function () {
            return $http({
                method: 'get',
                url: 'api/contextefiscal/annees'
            });
        };

        this.getLastValid = function () {
            return $http({
                method: 'get',
                url: 'api/contextefiscal/annee/last'
            });
        };

    }]);
